import { useCallback, useContext } from "react";
import { useUiData } from "./use-ui-data";
import { ApiDataContext } from "src/api";
import { formatPrice } from "src/utility";

export const usePriceFormatter = () => {
	const { currency } = useContext(ApiDataContext);
	const { localizer } = useUiData();
	const locale = localizer.locale;

	return useCallback(
		(price: number) =>
			formatPrice(price, {
				locale,
				currency,
			}),
		[currency, locale],
	);
};
